import { ListboxButton, useListboxContext } from '@reach/listbox';
import * as React from 'react';
import { useLegacyListboxInternalContext } from './legacy.listbox.context.js';
import { createComponent } from '../../../react/components/core/create-component.js';
/**
 * @deprecated Use new Listbox and its sub-components instead
 */

var LegacyListboxButtonWithLabel = createComponent({
  displayName: 'LegacyListboxButtonWithLabel',
  root: ListboxButton,
  propConfig: {
    classNames: ['swan-legacy-listbox-button-with-label'],
    derivedProps: function derivedProps() {
      var _useListboxContext = useListboxContext(),
          valueLabel = _useListboxContext.valueLabel,
          value = _useListboxContext.value;

      var _useLegacyListboxInte = useLegacyListboxInternalContext(),
          labelMap = _useLegacyListboxInte.labelMap;

      return {
        valueLabel: valueLabel,
        value: value,
        labelMap: labelMap
      };
    },
    wrapChildren: function wrapChildren(_props, derivedProps, element) {
      var labelMap = derivedProps.labelMap,
          value = derivedProps.value,
          valueLabel = derivedProps.valueLabel;
      return /*#__PURE__*/React.createElement(React.Fragment, null, element, /*#__PURE__*/React.createElement("span", {
        className: "swan-legacy-listbox-button-with-label-container"
      }, value !== null && labelMap[value] || valueLabel || value));
    }
  }
});
export { LegacyListboxButtonWithLabel };